import activations from '@/locales/fr/activations.js';
import deliveries from '@/locales/fr/deliveries.js';
import pagination from '@/locales/fr/pagination.js';
import auth from './auth.js';
import orders from './orders.js';
import dashboard from './dashboard.js';

export default {
    auth,
    orders,
    activations,
    deliveries,
    pagination,
    dashboard,
    global: {
        general: {
            cancel: 'Annuler',
            select: 'Choisissez...',
        },
        nav: {
            dashboard: 'Tableau de bord',
            orders: 'Commandes',
            activations: 'Activations',
            deliveries: 'Livraisons',
        },
        setting: {
            dropdown: {
                disconnect: 'Déconnexion',
                setting: 'Paramètres',
            },
        },
        status: {
            pending: 'En cours de validation',
            validated: 'Validée',
            completed: 'Complétée',
        },
        pagination: {
            results: 'Résultats',
            resultsString: '{name} {start}-{end} de {total}',
        },
        platform: {
            android: 'Android',
            pc: 'PC',
            oem: 'OEM',
        },
        404: {
            title: 'Page introuvable',
            description: 'La page recherchée est introuvable.',
        },
        allRightsReserved: 'Tous droits réservés.',
    },
};
